<template>
  <div class="risk-profile">
    <div class="header-card">
      <div class="close-btn">
        <img src="@/assets/close.png" height="18" width="18" alt="close-icon" @click="close()">
      </div>
      <div class="header-card-text">
        <p class="sub-text fnt-14">Your Risk profile is</p>
        <h3 class="primary">{{ message }}</h3>
      </div>
    </div>
      <div class="risk-profile-body">
        <h6 class="open-sans text-center mb-3">Risk Profile Meanings</h6>
        <div class="">
          <p class="cabin-family bold">Risk Averse</p>
          <ul>
            <li>Your sole objective is to preserve your capital and achieve returns based on
              prevailing deposit rates which may or may not keep pace with the rate of inflation.
              You are not willing to invest in any products where your capital is at risk.</li>
          </ul>
        </div>

        <div class="">
          <p class="cabin-family bold">Conservative</p>
          <ul>
            <li>You seek to achieve above deposit rate returns and protect your capital against
            inflation. You are willing to accept very low levels of investment risk over the
            medium term (up to 2 years).</li>
            <li>The value of your investment can fluctuate and may fall below your original
            investment. While volatility is expected to be low, short-term losses may be higher.
            </li>
          </ul>
        </div>

        <div class="">
          <p class="cabin-family bold">Moderate</p>
          <ul>
            <li>You seek to achieve a moderate level of capital growth on your investments and
            you are willing to accept moderate levels of investment risk over the medium to long
            term (up to 3 years).</li>
            <li>The value of your investments can fluctuate and may fall below your original
            investment. While volatility is expected to be moderate, short-term losses may be
            higher.
            </li>
          </ul>
        </div>

        <div class="">
          <p class="cabin-family bold">Moderately Aggressive</p>
          <ul>
            <li>You seek to achieve a moderate to high level of capital growth on your
            investments and you are willing to accept high levels of investment risk and
            volatility over the short, medium and long term.</li>
            <li>The value of your investments can experience high levels of fluctuations and may
            fall substantially below your original investment.</li>
          </ul>
        </div>

        <div class="">
          <p class="cabin-family bold">Aggressive</p>
          <ul>
            <li>You seek to achieve significant capital growth on your investments and you are
            willing to accept very high levels of investment risk and volatility over the short,
            medium and long term.</li>
            <li>The value of your investments can experience very high levels of fluctuations and
            may fall substantially below your original investment.</li>
          </ul>
        </div>

         <div class="">
          <p class="cabin-family bold">Very Aggressive</p>
          <ul>
            <li>You seek to achieve exceptional capital growth on your investments and you are
              willing to accept extreme levels of investment risk and volatility over the short,
              medium and long term.</li>
            <li>The value of your investments may fall substantially below your original investment,
            with the potential for you to lose the value of your entire investment.</li>
          </ul>
        </div>
      </div>

      <div class="literacy-footer text-center">

      </div>
  </div>
</template>

<script>
export default {
  props: ['message'],
  data() {
    return {
      q7: '',
      loading: false,
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped>
.risk-profile{
  min-height: 100vh;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  background-color: #F9F9F9;
  color: #000;
  &-body{
    text-align: left;
    padding: 1rem;
  }
}
.header-card-text{
  margin: .5rem auto;
}
.literacy-footer{
  position: relative;
  margin-top: 2rem;
  width: 100%;
}
p{
  margin-bottom: 0;
  margin-block-end: .5em;
}
</style>
